import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ar: {
    translation: {
      // UI translations (partial, will expand)
      "Family Tree Application": "تطبيق شجرة العائلة",
      "Logout": "تسجيل الخروج",
      "Export JSON": "تصدير JSON",
      "Export PDF": "تصدير PDF",
      "Export Image": "تصدير صورة",
      "Export Excel": "تصدير Excel",
      "Refresh": "تحديث",
      "Add New Member": "إضافة عضو جديد",
      "Add Family Unit": "إضافة وحدة عائلية",
      "Add Child to Family": "إضافة طفل إلى العائلة",
      "Family Members": "أفراد العائلة",
      "No family members found. Click \"Add New Member\" to add someone.": "لم يتم العثور على أفراد عائلة. انقر \"إضافة عضو جديد\" لإضافة شخص.",
      "Name": "الاسم",
      "Gender": "الجنس",
      "Birth Date": "تاريخ الميلاد",
      "Actions": "الإجراءات",
      "Children": "الأبناء",
      "Family Tree Summary": "ملخص شجرة العائلة",
      "Individuals": "الأفراد",
      "Family Units": "الوحدات العائلية",
      "Child Relationships": "علاقات الأبناء",
      "Emotional Relationships": "العلاقات العاطفية",
      "Last Updated": "آخر تحديث",
      "Click on individuals to view details. Drag individuals to reposition them. Use mouse wheel or buttons to zoom in/out. Drag the canvas to pan around.": "انقر على الأفراد لعرض التفاصيل. اسحب الأفراد لإعادة تموضعهم. استخدم عجلة الفأرة أو الأزرار للتكبير/التصغير. اسحب اللوحة للتنقل.",
      "Login": "تسجيل الدخول",
      "Password": "كلمة المرور",
      "First Name*": "الاسم الأول*",
      "Middle Name": "اسم الأب",
      "Last Name*": "اسم العائلة*",
      "Male": "ذكر",
      "Female": "أنثى",
      "Other": "آخر",
      "Save": "حفظ",
      "Cancel": "إلغاء",
      "Zoom In": "تكبير",
      "Zoom Out": "تصغير",
      "Reset View": "إعادة ضبط العرض",
      "Tree View": "عرض الشجرة",
      "List View": "عرض القائمة",
      "Add New Family Member": "إضافة فرد جديد إلى العائلة",
      "Add New Individual": "إضافة فرد جديد",
      "Edit Individual": "تعديل الفرد",
      "Add Profile Photo": "إضافة صورة شخصية",
      "Change Photo": "تغيير الصورة",
      "Max size: 5MB": "الحجم الأقصى: 5 ميجابايت",
      "Non-Binary": "غير ثنائي الجنس",
      "Custom": "مخصص",
      "Death Date": "تاريخ الوفاة",
      "dd/mm/yyyy": "يوم/شهر/سنة",
      "Deceased": "متوفى",
      "Birth Place": "مكان الميلاد",
      "Occupation": "المهنة",
      "Education": "التعليم",
      "Notes": "ملاحظات",
      "Add": "إضافة",
      "Select Partner 1": "اختر الشريك الأول",
      "Select Partner 2": "اختر الشريك الثاني",
      "Partner 1*": "الشريك الأول*",
      "Partner 2*": "الشريك الثاني*",
      "Select Child": "اختر الطفل",
      "Select Family Unit": "اختر وحدة عائلية",
      "Add Child": "إضافة طفل",
      "Remove": "إزالة",
      "Required field": "حقل مطلوب",
      "Create Family Unit": "إنشاء وحدة عائلية",
      "Relationship Type": "نوع العلاقة",
      "Married": "متزوج",
      "Marriage Date (Optional)": "تاريخ الزواج (اختياري)",
      "Family Unit*": "وحدة عائلية*",
      "Child*": "طفل*",
      "Parental Type": "نوع الوالدية",
      "Biological": "بيولوجي",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar',
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
